import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import OcurrenceSourcesPaginatedTable from "./table";
import { DataGridItem } from "components/data-grid";
import { getOcurrenceSource, postOcurrenceSource } from "../../../../services/commonService";
import DialogAddOcurrenceSource from "./dialog-add-ocurrence-source";
import Button from "components/buttons";

const useStyles = makeStyles(theme => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
    display: 'flex',
    alignItems: 'baseline',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  selectTypeEvent: {
    minWidth:220,
    marginBottom: "1rem",
  },

  bold: {
    fontWeight: 600,
    color: "red",
  },
  buttonCreated: {
    marginTop: "1rem",
  }
}));

export default function SelectEventTypeOnContract({ intl, items, contractId, styles }) {
  const classes = useStyles();
  const [eventType, setEventType] = useState(null);
  const [occurrencesSourceItems, setOccurrencesSourceItems] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [disabledCreateOccurrence, setDisabledCreateOccurrence] = useState(true);
  const [filteredOccurrences, setFilteredOccurrences] = useState([]);

  const LEVERADE = 'LEVERADE';
  const LOCAL= 'LOCAL';
  const OCCURRENCE_SOURCE = [LEVERADE, LOCAL];


  const compareOccurrences = () => {
    const occurrenceToFind = [...occurrencesSourceItems];
    return (occurrencesSourceItems?.length > 0 &&
            JSON.stringify(occurrenceToFind?.sort())===JSON.stringify(OCCURRENCE_SOURCE?.sort()));
  }

  const handleChange = event => {
    setEventType(event.target.value);
    if (!!contractId && event.target.value) {
      handleGetOccurrenceSource(event.target.value);
    } else {
      setOccurrencesSourceItems(null);
    }
  };

  //GET Ocurrence Source
  const handleSetInOccurrenceSourceItems = response => {
    setOccurrencesSourceItems(response.data);
  };

  const handleGetOccurrenceSource = (eventType) => {
      getOcurrenceSource(
        {
          contract_id: contractId,
          event_type_id: eventType?.id,
        },
        handleSetInOccurrenceSourceItems,
      );
    };

  const filterOccurrences = () => {
    const filtered = OCCURRENCE_SOURCE.filter(function(element){
      return !occurrencesSourceItems.find(item => item === element);
    });
    setFilteredOccurrences(filtered);
  }

  const handleClickOpenDialog = () => {
    filterOccurrences();
    setOpenDialog(true);
  };

  const handleCloseDialog = (data) => {
    handleGetOccurrenceSource(eventType);
    setOpenDialog(false);
  };

  useEffect( () => {
    const disabledButton = (!!!occurrencesSourceItems || compareOccurrences());
    setDisabledCreateOccurrence(disabledButton);
  }, [occurrencesSourceItems]);

  return (
    <div>
      {!!openDialog &&
        <DialogAddOcurrenceSource
            items={items}
            contractId={contractId}
            intl={intl}
            classes={classes}
            open={openDialog}
            handleClose={handleCloseDialog}
            eventType={eventType}
            occurrencesSourceToSelect={filteredOccurrences}
        />
      }

      <DataGridItem big>
        <div className={classes.button}>
          {intl.formatMessage({ id: "contract.allowedEventTypes" })}
        </div>
      </DataGridItem>
      <FormControl className={classes.formControl}>
        <div>
        <InputLabel id="demo-controlled-open-select-label" />
          <Select
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              value={eventType ? eventType : ''}
              onChange={handleChange}
              className={classes.selectTypeEvent}
          >
            <MenuItem value="">
              <em>{intl.formatMessage({ id: "asset.noselected" })}</em>
            </MenuItem>
            {items &&
            items.map(item => (
                <MenuItem key={item.description} value={item}>
                  {item.description}
                </MenuItem>
            ))}
          </Select>
          <DataGridItem big>
            {!!occurrencesSourceItems && (
                <OcurrenceSourcesPaginatedTable
                    eventType={eventType}
                    classesTIIVII={classes}
                    intl={intl}
                    items={occurrencesSourceItems}
                    handleGetOcurrenceSource={() => handleGetOccurrenceSource(eventType)}
                    contractId={contractId}
                />
            )}
          </DataGridItem>
          <div className={classes.buttonCreated}>
            <Button onClick={handleClickOpenDialog} disabled={disabledCreateOccurrence}>
              {intl.formatMessage({ id: "contract.ocurrenceSource.add" })}
            </Button>
          </div>
        </div>
      </FormControl>
    </div>
  );
}
